import Swiper from 'swiper/swiper-bundle';
import 'swiper/swiper-bundle.min.css';

const newsfeedFilterElems = document.querySelectorAll('.newsfeed-filters');

if (newsfeedFilterElems) {
	newsfeedFilterElems.forEach(filterElem => {
		const filtersSwiper = filterElem.querySelector('.newsfeed-filters__swiper');

		if (filtersSwiper) {
			const options = {
				slidesPerView: 'auto',
				spaceBetween: 35,
				centeredSlides: false,
				loop: false,
				shortSwipes: false,
				freeMode: true,
				keyboard: {
					enabled: true,
					onlyInViewport: true,
				},
				mousewheel: {
					enabled: true,
					forceToAxis: true,
				},
			};

			const swiper = new Swiper(filtersSwiper, options);
		}
	});
}
